import { commonMediaKeys, type FactoryKeyMap, type KeysConfig } from './common'

const factoryKeysWin: FactoryKeyMap = {
  Esc: '~_`',
  '!_1': 'F1',
  '@_2': 'F2',
  '#_3': 'F3',
  $_4: 'F4',
  '%_5': 'F5',
  '^_6': 'F6',
  '&_7': 'F7',
  '*_8': 'F8',
  '(_9': 'F9',
  ')_0': 'F10',
  '__-': 'F11',
  '+_=': 'F12',
  Insert: 'PrintScreen',
  Delete: 'ScrollLock',
  PgUp: 'Home',
  PgDn: 'End',
  '↑': 'SideLED_Color',
  Z: '|◄◄',
  X: '►||',
  C: '►►|',
  V: '📢➕',
  B: '📢➖',
  N: '📢✕',
  M: 'LED_Inc',
  Win_L: 'LEDMode_Forward',
  Space_L: 'LED_SI',
}

export const vt68Keys: KeysConfig = {
  factoryKeys: {
    win: factoryKeysWin,
    mac: { ...factoryKeysWin },
  },
  mediaKeys: [...commonMediaKeys],
}
